<template>
  <div class="home">
    <!--<h1>amplat プレーヤー</h1>-->
    <!--<h2>現在の環境は{{currentEnv}}環境です。</h2>-->
    <!--<h2>↓↓iframeによる埋め込み↓↓</h2>-->
    <!--<iframe v-bind:src="src" width="800" height="800" frameborder="0"></iframe><br><br>-->
    <!--<a v-bind:href="src">音声プレーヤーページへ</a><br><br>-->
    
    <!--<a v-bind:href="videoSrc">動画プレーヤーページへ</a>-->
    <!--<iframe :src="videoSrc" width="800" height="500" frameborder="0"></iframe>-->
  </div>
</template>

// <script>
//   import AmpluggedPlayer from '@/components/AmpluggedPlayer/AmpluggedPlayer';
  // import router from '@/router/index.js';

  export default {
    name: 'Home',
    components: {
      // AmpluggedPlayer
    },
    data() {
      return {
        //音源の指定
        // 'src': 'https://503bbb8438ca4187bfcf87038d497c35.vfs.cloud9.ap-northeast-1.amazonaws.com/#/nnctest/sword-slash1',
        src: '',
        audioSrc: 'https://stg.internal.amplugged.com/nnctest/audio/sword-slash1.mp3',
        videoSrc: 'https://dev.internal.amplugged.com/nnctest/video/Middle/inov_03/inov_03.m3u8',
        'currentEnv': process.env.VUE_APP_VUE_ENV
      }
    },
    mounted() {

      // console.log('現在の環境');
      // console.log(this.currentEnv);
      // console.log("URLの取得" + location.href);
      // this.src = location.href + 'nnctest/video/High/san11/san11.m3u8';
      this.src = location.href + 'nnctest/audio/matsuo_04.mp3';
      this.videoSrc = location.href + 'nnctest/video/Middle/inov_03/inov_03.m3u8';
      // router.push({ name: 'AudioPlayer' });
    }
  }
</script>
